<template>
  <div class="login-register-container">
    <div class="bg-image"></div>
    <div class="form-card" v-if="!showForgetPassword">
      <div class="tabs">
        <span
          :class="{ active: currentTab === 'login' }"
          @click="currentTab = 'login'"
        >
          {{ $t("login") }}
        </span>
        <span
          :class="{ active: currentTab === 'register' }"
          @click="currentTab = 'register'"
        >
          {{ $t("register") }}
        </span>
      </div>

      <!-- 登录表单 -->
      <el-form
        v-if="currentTab === 'login'"
        :model="loginForm"
        :rules="loginRules"
        ref="loginFormRef"
        label-width="120px"
        key="loginFormKey"
      >
        <el-form-item :label="$t('phone')" prop="phone">
          <el-input
            v-model="loginForm.phone"
            :placeholder="$t('pleaseEnterPhone')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('password')" prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            :placeholder="$t('pleaseEnterPassword')"
          ></el-input>
        </el-form-item>
        <el-form-item class="captcha" :label="$t('captcha')" prop="captcha">
          <el-input
            v-model="loginForm.captcha"
            :placeholder="$t('pleaseEnterCaptcha')"
            style="width: 60%; margin-right: 10px"
          ></el-input>
          <span style="cursor: pointer" @click="refreshCaptcha">
            <s-identify :identifyCode="identifyCode"></s-identify>
          </span>
        </el-form-item>
        <el-form-item class="btn">
          <el-button size="nomal" type="primary" @click="handleLogin">
            {{ $t("login") }}
          </el-button>
        </el-form-item>
      </el-form>

      <!-- 注册表单 -->
      <el-form
        v-if="currentTab === 'register'"
        :model="registerForm"
        :rules="registerRules"
        ref="registerFormRef"
        label-width="120px"
        key="registerFormKey"
      >
        <el-form-item :label="$t('username')" prop="name">
          <el-input
            v-model="registerForm.name"
            :placeholder="$t('pleaseEnterUsername')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('password')" prop="password">
          <el-input
            type="password"
            v-model="registerForm.password"
            :placeholder="$t('pleaseEnterPassword')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('phone')" prop="phone">
          <el-input
            v-model="registerForm.phone"
            :placeholder="$t('pleaseEnterPhone')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('smscode')" prop="smsCode">
          <el-input
            v-model="registerForm.smsCode"
            :placeholder="$t('pleaseEnterCaptcha')"
            style="width: 60%; margin-right: 10px"
          ></el-input>
          <el-button
            class="captcha-btn"
            size="nomal"
            :disabled="countDown > 0"
            @click="sendSmsCode"
          >
            {{
              countDown > 0
                ? `${countDown}${$t("resendAfter")}`
                : $t("getCaptcha")
            }}
          </el-button>
        </el-form-item>
        <el-form-item class="btn">
          <el-button size="nomal" type="primary" @click="handleRegister">
            {{ $t("register") }}
          </el-button>
        </el-form-item>
      </el-form>

      <div class="forget-password" @click="showForgetPassword = true">
        {{ $t("forgetPassword") }}
      </div>
    </div>

    <!-- 找回密码 -->
    <div class="form-card" v-else>
      <span class="title">{{ $t("findPassword") }}</span>
      <el-form
        :model="forgetForm"
        :rules="forgetRules"
        ref="forgetFormRef"
        label-width="140px"
        key="forgetFormKey"
      >
        <el-form-item :label="$t('phone')" prop="phone">
          <el-input
            v-model="forgetForm.phone"
            :placeholder="$t('pleaseEnterRegisterPhone')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('smscode')" prop="smsCode">
          <el-input
            v-model="forgetForm.smsCode"
            :placeholder="$t('pleaseEnterCaptcha')"
            style="width: 60%; margin-right: 10px"
          ></el-input>
          <el-button
            class="captcha-btn"
            size="normal"
            :disabled="forgetCountDown > 0"
            @click="sendForgetSmsCode"
          >
            {{
              forgetCountDown > 0
                ? `${forgetCountDown}${$t("resendAfter")}`
                : $t("getCaptcha")
            }}
          </el-button>
        </el-form-item>
        <el-form-item :label="$t('newPassword')" prop="password">
          <el-input
            type="password"
            v-model="forgetForm.password"
            :placeholder="$t('pleaseEnterPassword')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('confirmPassword')" prop="repeatPassword">
          <el-input
            type="password"
            v-model="forgetForm.repeatPassword"
            :placeholder="$t('pleaseRepeatPassword')"
          ></el-input>
        </el-form-item>
        <el-form-item class="btn">
          <el-button size="normal" type="primary" @click="handleForgetPassword">
            {{ $t("resetPassword") }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="forget-password" @click="showForgetPassword = false">
        <i class="el-icon-right"></i>{{ $t("backToLogin") }}
      </div>
    </div>
  </div>
</template>

<script>
import SIdentify from "../components/identity/identity.vue";
export default {
  components: { SIdentify },
  data() {
    return {
      identifyCode: "",
      identifyCodes: "123456789ABCDEFGHGKMNPQRSTUVWXY",
      name: "SIdentify",
      currentTab: "login",
      loginForm: { phone: "", password: "", captcha: "" },
      registerForm: { name: "", password: "", phone: "", smsCode: "" },
      forgetForm: { phone: "", smsCode: "", password: "", repeatPassword: "" },
      loginRules: {
        phone: [
          {
            required: true,
            message: this.$t("pleaseEnterPhone"),
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("pleaseEnterValidPhone"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("pleaseEnterPassword"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: this.$t("passwordLength"),
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: this.$t("pleaseEnterCaptcha"),
            trigger: "blur",
          },
        ],
      },
      registerRules: {
        name: [
          {
            required: true,
            message: this.$t("pleaseEnterUsername"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 10,
            message: this.$t("usernameLength"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("pleaseEnterPassword"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: this.$t("passwordLength"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("pleaseEnterPhone"),
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("pleaseEnterValidPhone"),
            trigger: "blur",
          },
        ],
        smsCode: [
          {
            required: true,
            message: this.$t("pleaseEnterCaptcha"),
            trigger: "blur",
          },
          {
            min: 4,
            max: 4,
            message: this.$t("captchaLength"),
            trigger: "blur",
          },
        ],
      },
      forgetRules: {
        phone: [
          {
            required: true,
            message: this.$t("pleaseEnterPhone"),
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("pleaseEnterValidPhone"),
            trigger: "blur",
          },
        ],
        smsCode: [
          {
            required: true,
            message: this.$t("pleaseEnterCaptcha"),
            trigger: "blur",
          },
          {
            min: 4,
            max: 4,
            message: this.$t("captchaLength"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("pleaseEnterPassword"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: this.$t("passwordLength"),
            trigger: "blur",
          },
        ],
        repeatPassword: [
          {
            required: true,
            message: this.$t("pleaseRepeatPassword"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: this.$t("passwordLength"),
            trigger: "blur",
          },
        ],
      },
      countDown: 0,
      showForgetPassword: false,
      forgetCountDown: 0,
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  created() {
    this.getRandomString();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {},
    refreshCaptcha() {
      this.identifyCode = "";
      this.getRandomString();
    },
    getRandomString() {
      this.$post("/get_captcha").then((response) => {
        this.identifyCode = response.data.data;
      });
    },
    sendSmsCode() {
      this.$refs.registerFormRef.validateField("phone", (error) => {
        if (error) return;
        this.$get("/send_sms_code", { mobile: this.registerForm.phone }).then(
          (res) => {
            if (res.data.code == 1) {
              this.$message.success("验证码已发送");
              this.countDown = 60;
              const timer = setInterval(() => {
                this.countDown--;
                if (this.countDown <= 0) clearInterval(timer);
              }, 1000);
            } else {
              this.$message.error(res.data.msg);
            }
          },
        );
      });
    },
    handleLogin() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          this.login(this.loginForm);
        } else {
          this.$message.error(this.$t("formValidateFailed"));
          return false;
        }
      });
    },
    login(formData) {
      this.$post("/login", formData).then((res) => {
        if (res.data.code == 1) {
          this.$cookies.set(
            "userInfo",
            {
              userid: res.data.data.id,
              phone: res.data.data.phone,
              avatarimg: res.data.data.avatarimg,
              name: res.data.data.name,
            },
            60 * 60 * 24 * 7,
          );
          this.$message({
            message: this.$t("loginSuccess"),
            type: "success",
            duration: 800,
            onClose: () => {
              this.$router.push({ path: "/" });
              window.location.reload();
            },
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleRegister() {
      this.$refs.registerFormRef.validate((valid) => {
        if (valid) {
          this.register(this.registerForm);
        } else {
          this.$message.error(this.$t("formValidateFailed"));
          return false;
        }
      });
    },
    register(formData) {
      this.$post("/register", formData).then((res) => {
        if (res.data.code == 1) {
          this.$alert(this.$t("goToLogin"), this.$t("registerSuccess"), {
            confirmButtonText: "确定",
            callback: () => {
              window.location.reload();
            },
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    sendForgetSmsCode() {
      this.$refs.forgetFormRef.validateField("phone", (error) => {
        if (error) return;
        this.$get("/send_forget_sms_code", {
          mobile: this.forgetForm.phone,
        }).then((res) => {
          if (res.data.code == 1) {
            this.$message.success("验证码已发送");
            this.forgetCountDown = 60;
            const timer = setInterval(() => {
              this.forgetCountDown--;
              if (this.forgetCountDown <= 0) clearInterval(timer);
            }, 1000);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    handleForgetPassword() {
      this.$refs.forgetFormRef.validate((valid) => {
        if (valid) this.resetPassword(this.forgetForm);
      });
    },
    resetPassword(formData) {
      this.$post("/reset_password", formData).then((res) => {
        if (res.data.code == 1) {
          this.$alert(this.$t("goToLogin"), this.$t("passwordResetSuccess"), {
            confirmButtonText: "确定",
            callback: () => {
              this.showForgetPassword = false;
              window.location.reload();
            },
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.login-register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  overflow: hidden;
}
.bg-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/service_bac.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  z-index: -1;
}
.form-card {
  position: relative;
  z-index: 1;
  width: 500px;
  padding: 30px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
.tabs {
  display: flex;
  margin-bottom: 20px;
  font-size: 18px;
}
.tabs span {
  flex: 1;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}
.tabs span.active {
  color: #409eff;
  border-bottom-color: #409eff;
}
::v-deep.captcha .el-form-item__content {
  display: flex;
}
.btn .el-button {
  width: 80%;
}
.title {
  display: block;
  text-align: center;
  font-size: 18px;
  color: #409eff;
  margin-bottom: 20px;
  padding: 10px;
}
.forget-password {
  text-align: right;
  font-size: 0.9em;
  color: #409eff;
  cursor: pointer;
  margin-top: 10px;
}
@media (max-width: 768px) {
  .form-card {
    width: 90%;
    padding: 20px;
  }
  .tabs {
    font-size: 16px;
  }
  .btn .el-button {
    width: 100%;
  }
  .captcha-btn {
    padding: 12px 10px;
  }
  .forget-password {
    font-size: 0.85em;
  }
}
</style>
